export enum ExpeditionRoutes {
    IDLE = "expeditionIdle",
    SETTINGS = "expeditionSettings",
    LOAD_CONTAINER = "expeditionLoadContainer",
    SIGNIN = "expeditionLogin",
    CONTAINER_VIEW = "expeditionContainerView",
}

export enum TestExpeditionRoutes {
    IDLE = "testExpeditionIdle",
    SETTINGS = "testExpeditionSettings",
    LOAD_CONTAINER = "testExpeditionLoadContainer",
    SIGNIN = "testExpeditionLogin",
    CONTAINER_VIEW = "testExpeditionContainerView",
}
